import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  isUserNeedBankAccountNumbers,
  isUserNeedKyc,
  Kyc,
  NotificationManager,
  useApplicationState,
  VerificationManager,
} from '@atlas/core';
import { Button } from '@atlas/ui';

import { goToAccountNumbersPage, goToVerificationPage } from 'src/helpers/verification';

const VerificationButton = ({ buttonSize = 'big', isTerminal, label = 'go_to_kyc', onClick }) => {
  const { account } = useApplicationState();

  const terminalKycVerification = useCallback(async () => {
    const { type: provider } = await Kyc.getKycVerificationType();
    const { initAttributes } = await Kyc.initKycProvider({
      cpf: account.docNumber,
      kycType: provider,
    });

    const options = {
      attributes: initAttributes,
      cpf: account.docNumber,
      provider,
    };

    await VerificationManager.startVerification(options);

    NotificationManager.notify({
      message: 'withdrawal_verification_completed_successfully',
      status: 'success',
      type: 'notification',
    });
  }, [account]);

  const processVerification = useCallback(() => {
    onClick?.();

    if (isTerminal) {
      terminalKycVerification();
      return;
    }

    if (isUserNeedKyc(account)) {
      goToVerificationPage();
    } else if (isUserNeedBankAccountNumbers(account)) {
      goToAccountNumbersPage();
    }
  }, [account, isTerminal, onClick, terminalKycVerification]);

  return (
    <Button
      className="betslip-verify-button"
      label={label}
      onClick={processVerification}
      size={buttonSize}
    />
  );
};

VerificationButton.propTypes = {
  buttonSize: PropTypes.string,
  isTerminal: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

export default VerificationButton;
